const zh = {
  kicker: "面向本地商家与房主",
  title: "成为 Trollfossjakten 接待点。",
  lead: "接待点是 Lavangen 与 Årstein（Gratangen）之间步道沿线的本地商家或房主——咖啡馆、农场、小木屋、民宿、桑拿或商店。接待点欢迎寻宝游戏的客人，并接受游戏专属货币巨魔克朗（TK）付款。",
  badges: ["免费", "约 2 分钟", "立即出现在地图上"],
  waysKicker: "两种参与方式",
  waysTitle: "选一种——或两种都参加。",
  ways: [
    { title: "接待点", tag: "接受巨魔克朗", body: "你会出现在地图上，客人可以用钱包里的 TK 向你付款。" },
    { title: "休息站", tag: "仅展示", body: "一个地图图钉，展示你的服务，例如汽车或自行车充电、淋浴、餐单、民宿、露营、无线网络、停车、厕所和咖啡。免费曝光——不涉及收款。" },
  ],
  both: "两种方式可以同时参加。",
  joinKicker: "如何成为接待点",
  joinTitle: "大约 2 分钟，而且免费。",
  steps: ["下载应用并登录。", "前往 个人资料 → 成为接待点 → 注册为接待点。", "填写你的信息（见列表）。", "完成——你会立即出现在地图上。"],
  formTitle: "需要填写",
  fields: [["商家名称", "必填"], ["地址", "必填"], ["电话", "选填"], ["你提供的服务", "例如“咖啡、华夫饼、桑拿”"]],
  amenitiesTitle: "你的设施",
  noWait: "无需等待审核，也无需报名费。",
  pitTitle: "添加休息站",
  pitBody: "前往 个人资料 → 开设休息站 → 注册休息站，然后填写名称、地址、电话、地图位置和设施。",
  tkKicker: "巨魔克朗如何运作",
  tkTitle: "1 TK = 1 挪威克朗。",
  tkEarnTitle: "客人通过以下方式获得 TK",
  tkEarn: ["邀请朋友——朋友首次购买通行证时返还 50%", "Arrow Hunter 等级奖励：+10 / +25 / +100 TK", "幸运转盘"],
  tkRule: "TK 只能在已注册的接待点使用，客人无法提现。",
  payKicker: "收款",
  payTitle: "接待点后台帮你算好账。",
  paySteps: ["客人打开 个人资料 → 显示我的付款二维码。", "你扫描二维码或输入他们的钱包代码（TK-XXXXXX）。", "输入挪威克朗金额和购买内容，例如“咖啡和华夫饼”。", "应用会尽量从 TK 余额中扣除，并显示需用现金或银行卡收取的剩余金额。"],
  exampleTitle: "示例",
  example: { note: "消费 85 克朗，钱包里有 60 TK", total: "消费", tk: "用 TK 支付", rest: "需用现金或银行卡收取" },
  dashboard: "后台会显示每一笔销售，以及今日和累计收到的 TK。",
  ctaTitle: "准备好迎接巨魔客人了吗？",
  ctaBody: "下载应用、登录并注册为接待点——大约只需两分钟。",
  cta: "下载应用",
  ctaPartner: "也想拥有自己的巨魔？查看合作套餐",
  ctaHost: "注册为接待点",
  webNote: "更喜欢用网页？在这里注册——在地图上标出你的地点，告诉我们你提供什么，并勾选你的设施。",
};

export default zh;
